.deleteText {
    padding-bottom: 10px;
}
